import type { Island } from '@rta/rta-blueprint-library';

// Top surface elevation: island's configured base height + countertop material thickness.
export const getCountertopTopElevation = (island: Island): number => {
	const height = typeof island.size.height === 'number' ? island.size.height : 0;
	return height + (island.getCountertop()?.material?.thickness ?? 0);
};
